import Vue from 'vue'
import nodata from '@/assets/images/nodata.svg'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
VXETable.renderer.add('NotData', {
  // 空内容模板
  renderEmpty (h, renderOpts) {
    let nodata = renderOpts.nodata
    return h('div',{
      'class': {
        vxeEmpty: true,
      }
    },
    [
      h('img', {
        style: {
          marginTop: '32px',
          width: '64px',
        },
        attrs: {
          src: require('@/assets/images/empty.svg')
        }
      }),
      h('p', { 
        style: {
          marginTop: '16px',
          marginBottom: '0'
        },
      },'暂无数据')
    ])    
  }
})
Vue.use(VXETable)